// import React, { useState, useEffect, useMemo } from "react";
// import { useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import Select from "react-select";
// import CustomTimePicker from "../components/CustomTimePicker";
// import {
//   MapPin,
//   X,
//   Calendar as CalendarIcon,
//   ArrowRight,
//   Truck,
//   CheckCircle,
// } from "lucide-react";
// import { getAllWorkAreas } from "../services/workAreaService";
// import api from "../services/api";
// import bookingWS from "../services/bookingWebSocket";

// // ─── helpers ────────────────────────────────────────────────────────────────

// const formatDate = (date) => {
//   const y = date.getFullYear();
//   const m = String(date.getMonth() + 1).padStart(2, "0");
//   const d = String(date.getDate()).padStart(2, "0");
//   return `${y}-${m}-${d}`;
// };

// const formatDateTime = (date, time) => `${date} ${time}:00`;

// const haversineKm = (lat1, lng1, lat2, lng2) => {
//   const R = 6371;
//   const dLat = ((lat2 - lat1) * Math.PI) / 180;
//   const dLng = ((lng2 - lng1) * Math.PI) / 180;
//   const a =
//     Math.sin(dLat / 2) ** 2 +
//     Math.cos((lat1 * Math.PI) / 180) *
//       Math.cos((lat2 * Math.PI) / 180) *
//       Math.sin(dLng / 2) ** 2;
//   return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
// };

// const extractCoords = (raw) => {
//   if (!raw) return null;
//   const pick = (obj, keys) => {
//     for (const k of keys) {
//       if (obj[k] !== undefined && obj[k] !== null && obj[k] !== "") {
//         const n = parseFloat(obj[k]);
//         if (!Number.isNaN(n)) return n;
//       }
//     }
//     return null;
//   };
//   const latKeys = [
//     "latitude","Latitude","lat","LAT","Lat","LatitudeValue",
//     "WALatitude","WA_Latitude","WA_latitude","WaLatitude","WALat",
//     "WorkAreaLatitude","workAreaLatitude","work_area_latitude",
//   ];
//   const lngKeys = [
//     "longitude","Longitude","lng","LNG","Long","LongitudeValue",
//     "WALongitude","WA_Longitude","WA_longitude","WaLongitude","WALong",
//     "WorkAreaLongitude","workAreaLongitude","work_area_longitude",
//   ];
//   let latNum = pick(raw, latKeys);
//   let lngNum = pick(raw, lngKeys);
//   if (latNum === null || lngNum === null) {
//     const keys = Object.keys(raw || {});
//     const lk = keys.find((k) => k.toLowerCase().includes("lat"));
//     const nk = keys.find(
//       (k) =>
//         k.toLowerCase().includes("lon") ||
//         k.toLowerCase().includes("lng") ||
//         k.toLowerCase().includes("long")
//     );
//     if (latNum === null && lk) { const n = parseFloat(raw[lk]); if (!isNaN(n)) latNum = n; }
//     if (lngNum === null && nk) { const n = parseFloat(raw[nk]); if (!isNaN(n)) lngNum = n; }
//   }
//   if (latNum === null || lngNum === null) return null;
//   return { lat: latNum.toFixed(6), lng: lngNum.toFixed(6) };
// };

// // ─── component ──────────────────────────────────────────────────────────────

// export default function AdvancedBookingForm({ onBookingCreated, onClose }) {
//   const { userDetails, authKey } = useSelector((s) => s.auth);

//   const now = new Date();
//   const todayStr = formatDate(now);
 
//   const getCurrentTime = () => {
//     const hours = String(now.getHours()).padStart(2, "0");
//     const minutes = String(now.getMinutes()).padStart(2, "0");
//     return `${hours}:${minutes}`;
//   };

//   const currentTime = getCurrentTime();

//   // ── state ────────────────────────────────────────────────────────────────

//   const [selectedWeight, setSelectedWeight] = useState("");
//   const [weightOptions, setWeightOptions] = useState([]); 
//   const [loadingWeights, setLoadingWeights] = useState(false); 
//   const [forkliftVehicles, setForkliftVehicles] = useState([]);
//   const [loadingVehicles, setLoadingVehicles] = useState(false);
//   const [workAreas, setWorkAreas] = useState([]);
//   const [loadingWorkAreas, setLoadingWorkAreas] = useState(false);
//   const [driverLocation, setDriverLocation] = useState(null);

//   const [fromLocation, setFromLocation] = useState(null);
//   const [toLocation, setToLocation] = useState(null);

//   const [suggestedVehicles, setSuggestedVehicles] = useState([]);
//   const [selectedVehicle, setSelectedVehicle] = useState(null);

//   const [selectedDate, setSelectedDate] = useState(todayStr);
//   const [bsTime, setBsTime] = useState(currentTime);
//   const [timeError, setTimeError] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // Success overlay state
//   const [showBookingOverlay, setShowBookingOverlay] = useState(false);
//   const [submittedBooking, setSubmittedBooking] = useState(null);

//   // ── WebSocket Connection ─────────────────────────────────────────────────
//   useEffect(() => {
//     if (authKey) { 
//       bookingWS.connectAsEmployee(authKey);
//       console.log("[AdvancedBookingForm] Connected to booking WebSocket");
//     }
//   }, [authKey]);

//   // ── Fetch Weight Categories Dynamically ─────────────────────────────────
//   useEffect(() => {
//     const fetchWeightCategories = async () => {
//       setLoadingWeights(true);
//       try {
//         const res = await api.get("/VehicleDetails/GetVehicleDetails");
//         let data =
//           res.data?.resultSet ??
//           res.data?.data ??
//           (Array.isArray(res.data) ? res.data : []);
         
//         const forklifts = data.filter(
//           (v) => v.vehicleType?.toLowerCase() === "forklift"
//         ); 
//         const uniqueWeights = [...new Set(forklifts.map(v => v.weightCat).filter(w => w))];
         
//         const sortOrder = ["3T", "5T", "7T", "10T", "15T", "20T", "25T", "30T"];
//         const sortedWeights = uniqueWeights.sort((a, b) => {
//           const aIndex = sortOrder.indexOf(a);
//           const bIndex = sortOrder.indexOf(b);
//           if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
//           if (aIndex !== -1) return -1;
//           if (bIndex !== -1) return 1;
//           return a.localeCompare(b);
//         });
         
//         const colorMap = {
//           "3T": "bg-blue-100 text-blue-700 border-blue-300",
//           "5T": "bg-green-100 text-green-700 border-green-300",
//           "7T": "bg-yellow-100 text-yellow-700 border-yellow-300",
//           "10T": "bg-orange-100 text-orange-700 border-orange-300",
//           "15T": "bg-red-100 text-red-700 border-red-300",
//           "20T": "bg-gray-200 text-gray-700 border-gray-400",
//           "25T": "bg-purple-100 text-purple-700 border-purple-300",
//           "30T": "bg-pink-100 text-pink-700 border-pink-300",
//         };
        
//         const options = sortedWeights.map(weight => ({
//           value: weight,
//           label: weight,
//           color: colorMap[weight] || "bg-gray-100 text-gray-700 border-gray-300"
//         }));
        
//         setWeightOptions(options);
//         console.log("[AdvancedBookingForm] Loaded weight categories:", options);
//       } catch (error) {
//         console.error("[AdvancedBookingForm] Failed to load weight categories:", error);
//         toast.error("Failed to load weight categories");
//       } finally {
//         setLoadingWeights(false);
//       }
//     };
    
//     fetchWeightCategories();
//   }, []);

//   // ── data fetching ─────────────────────────────────────────────────────────

//   useEffect(() => {
//     (async () => {
//       setLoadingVehicles(true);
//       try {
//         const res = await api.get("/VehicleDetails/GetVehicleDetails");
//         let data =
//           res.data?.resultSet ??
//           res.data?.data ??
//           (Array.isArray(res.data) ? res.data : []);
//         setForkliftVehicles(
//           data.filter(
//             (v) =>
//               v.vehicleType?.toLowerCase() === "forklift" &&
//               v.status?.toLowerCase() === "active"
//           )
//         );
//       } catch {
//         toast.error("Failed to load forklift vehicles");
//       } finally {
//         setLoadingVehicles(false);
//       }
//     })();
//   }, []);

//   useEffect(() => {
//     (async () => {
//       setLoadingWorkAreas(true);
//       try {
//         const data = await getAllWorkAreas();
//         setWorkAreas(
//           data.map((item) => ({
//             WAcode: item.WAcode || item.code || item.waCode,
//             WAname: item.WAname || item.name || item.waName,
//             status: item.status || item.Status,
//             raw: item,
//           }))
//         );
//       } catch {
//         toast.error("Failed to load locations");
//       } finally {
//         setLoadingWorkAreas(false);
//       }
//     })();
//   }, []);

//   useEffect(() => {
//     navigator.geolocation?.getCurrentPosition(
//       (p) => setDriverLocation({ lat: p.coords.latitude, lng: p.coords.longitude }),
//       () => {}
//     );
//   }, []);

//   // ── active work-area options ──────────────────────────────────────────────

//   const locationOptions = useMemo(() => {
//     return workAreas
//       .filter((w) => {
//         const s = String(w.status || "").trim().toLowerCase();
//         return ["active", "a", "1", "true", "yes"].includes(s);
//       })
//       .map((w) => {
//         const coords = extractCoords(w.raw);
//         return {
//           value: w.WAcode,
//           label: w.WAname,
//           raw: w.raw,
//           lat: coords ? parseFloat(coords.lat) : null,
//           lng: coords ? parseFloat(coords.lng) : null,
//         };
//       });
//   }, [workAreas]);
 
//   useEffect(() => {
//     if (!selectedWeight || !fromLocation || !toLocation) {
//       setSuggestedVehicles([]);
//       setSelectedVehicle(null);
//       return;
//     }

//     const weightMatched = forkliftVehicles.filter(
//       (v) => v.weightCat === selectedWeight && v.oStatus === "Online"
//     );

//     if (weightMatched.length === 0) {
//       setSuggestedVehicles([]);
//       setSelectedVehicle(null);
//       return;
//     }

//     const fromLat = fromLocation.lat;
//     const fromLng = fromLocation.lng;

//     const sorted = [...weightMatched].sort((a, b) => {
//       if (!fromLat || !fromLng) return 0;
//       const aLat = parseFloat(a.latitude || a.lat || a.currentLat || 0);
//       const aLng = parseFloat(a.longitude || a.lng || a.currentLng || 0);
//       const bLat = parseFloat(b.latitude || b.lat || b.currentLat || 0);
//       const bLng = parseFloat(b.longitude || b.lng || b.currentLng || 0);
//       const da = aLat && aLng ? haversineKm(fromLat, fromLng, aLat, aLng) : 9999;
//       const db = bLat && bLng ? haversineKm(fromLat, fromLng, bLat, bLng) : 9999;
//       return da - db;
//     });

//     setSuggestedVehicles(sorted);
//     setSelectedVehicle(sorted[0]);
//   }, [selectedWeight, fromLocation, toLocation, forkliftVehicles]);

//   // ── time validation ───────────────────────────────────────────────────────

//   const validateTime = (time) => {
//     if (!/^([0-1]?\d|2[0-3]):[0-5]\d$/.test(time)) {
//       setTimeError("Invalid time format. Please use HH:MM");
//       return false;
//     }
//     setTimeError("");
//     return true;
//   };

//   const handleTimeChange = (newTime) => {
//     setBsTime(newTime);
//     if (validateTime(newTime)) {
//       console.log("[AdvancedBookingForm] Time updated to:", newTime);
//     }
//   };

//   // ✅ FIXED: Schedule WebSocket notification for the future (not immediate)
//   const scheduleWebSocketNotification = (bookingData, scheduledDateTime) => {
//     const scheduledTime = new Date(scheduledDateTime);
//     const now = new Date();
//     const delayMs = scheduledTime.getTime() - now.getTime();
    
//     console.log(`[AdvancedBookingForm] 📅 Scheduling alert for: ${scheduledDateTime}`);
//     console.log(`[AdvancedBookingForm] ⏰ Delay: ${Math.floor(delayMs / 1000)} seconds`);
    
//     if (delayMs <= 0) {
//       // If time is in past, send immediately
//       console.warn("[AdvancedBookingForm] ⚠️ Scheduled time is in the past, sending immediately");
//       sendWebSocketNotification(bookingData, scheduledDateTime);
//       return;
//     }
    
//     // Schedule the notification for the future
//     setTimeout(() => {
//       console.log(`[AdvancedBookingForm] 🔔 Time reached! Sending alert for booking at ${scheduledDateTime}`);
//       sendWebSocketNotification(bookingData, scheduledDateTime);
//     }, delayMs);
    
//     toast.info(`📅 Booking scheduled for ${scheduledDateTime}. Driver will be notified at that time.`);
//   };

//   // Send WebSocket notification (called only when scheduled time arrives)
//   const sendWebSocketNotification = (bookingData, scheduledDateTime) => {
//     if (!scheduledDateTime) {
//       console.error("[AdvancedBookingForm] ❌ Missing scheduled time");
//       return;
//     }

//     console.log("[AdvancedBookingForm] 📤 Sending booking alert to driver for:", scheduledDateTime);
    
//     toast.info(`🔔 Booking alert sent to driver for ${scheduledDateTime}`);
    
//     _doSendWS(bookingData, scheduledDateTime);
//   };

//   // Helper - actual WS send logic with retry
//   const _doSendWS = (bookingData, scheduledDateTime, retryCount = 0) => {
//     if (bookingWS.isReady()) {
//       const wsPayload = {
//         ...bookingData,
//         type: "new_booking",
//         action: "create_booking",
//         timestamp: new Date().toISOString(),
//         bookingTime: scheduledDateTime,
//         // Important: Mark as scheduled booking
//         BookingStatus: "S", // S = Scheduled Booking
//         isScheduled: true,
//         scheduledFor: scheduledDateTime,
//       };
//       const sent = bookingWS.sendBooking(wsPayload);
//       if (sent) {
//         console.log("[AdvancedBookingForm] ✅ WS notification sent at:", new Date().toISOString());
//       } else {
//         console.warn("[AdvancedBookingForm] ⚠️ Failed to send WS notification");
//       }
//     } else if (retryCount < 3) {
//       console.warn(`[AdvancedBookingForm] ⚠️ WebSocket not ready - retry ${retryCount + 1}/3 in 1s...`);
//       setTimeout(() => {
//         _doSendWS(bookingData, scheduledDateTime, retryCount + 1);
//       }, 1000 * (retryCount + 1));
//     } else {
//       console.error("[AdvancedBookingForm] ❌ WebSocket still not ready after 3 retries - notification failed");
//       toast.error("Failed to send alert to driver. Driver may not receive notification immediately.");
//     }
//   };

//   const processBookingResponse = async (responseData, payload, bookingDateTime) => {
//     if (!bookingDateTime) {
//       console.error("[AdvancedBookingForm] ❌ Missing bookingDateTime in processBookingResponse");
//       throw new Error("Booking date time is required");
//     }
    
//     let actualBookingId = null;

//     if (responseData?.resultSet?.[0]?.bId) {
//       actualBookingId = responseData.resultSet[0].bId;
//     } else if (responseData?.result?.bId) {
//       actualBookingId = responseData.result.bId;
//     } else if (responseData?.bId) {
//       actualBookingId = responseData.bId;
//     } else if (responseData?.id) {
//       actualBookingId = responseData.id;
//     }

//     if (!actualBookingId) {
//       try {
//         console.log("[AdvancedBookingForm] bId missing from response, fetching from API...");
//         const bookingsRes = await api.get("/BookingDetails/GetBookingDetails");
//         const allBookings = bookingsRes.data?.resultSet || [];
        
//         const matched = allBookings
//           .filter(b =>
//             b.vId === payload[0].vId &&
//             b.dSNo === payload[0].dSNo &&
//             (b.status === "P" || b.status === "Pending")
//           )
//           .sort((a, b) => parseInt(b.bId) - parseInt(a.bId))[0];

//         if (matched?.bId) {
//           actualBookingId = matched.bId;
//           console.log("[AdvancedBookingForm] ✅ Fetched bId from API:", actualBookingId);
//         }
//       } catch (err) {
//         console.warn("[AdvancedBookingForm] Failed to fetch bId:", err);
//       }
//     }

//     const bookingForAlert = {
//       bId: actualBookingId,
//       vId: payload[0].vId,
//       dSNo: payload[0].dSNo,
//       employeeName: userDetails?.Name || "Employee",
//       slatitude: payload[0].slatitude,
//       slongitude: payload[0].slongitude,
//       elatitude: payload[0].elatitude,
//       elongitude: payload[0].elongitude,
//       totalDestence: "0",
//       bookingDT: bookingDateTime,
//       bsTime: bookingDateTime, // Scheduled start time
//       beTime: null,
//       status: "P",
//       bookingSno: userDetails?.ServiceNo || "",
//       dlatitude: payload[0].dlatitude,
//       dlongitude: payload[0].dlongitude,
//       From: payload[0].From,
//       TO: payload[0].TO,
//       vehicleType: "Forklift",
//       weightCat: selectedWeight,
//       BookingStatus: "S", // S = Scheduled Booking
//       isScheduled: true,
//     };

//     // ✅ Schedule notification for the future (not immediate)
//     if (bookingDateTime) {
//       scheduleWebSocketNotification(bookingForAlert, bookingDateTime);
//     } else {
//       console.error("[AdvancedBookingForm] ❌ Skipping WebSocket notification: Invalid booking time");
//     }
    
//     return { actualBookingId, bookingForAlert };
//   };

//   // ── submit ────────────────────────────────────────────────────────────────

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!selectedWeight)  { toast.error("Please select weight category."); return; }
//     if (!fromLocation)    { toast.error("Please select From location."); return; }
//     if (!toLocation)      { toast.error("Please select To location."); return; }
//     if (fromLocation.value === toLocation.value) {
//       toast.error("From and To locations cannot be the same.");
//       return;
//     }
//     if (!selectedVehicle) { toast.error("No vehicle available for this selection."); return; }
//     if (!bsTime)          { toast.error("Please select start time."); return; }
    
//     // Validate time format
//     if (!validateTime(bsTime)) {
//       toast.error("Please enter a valid time in HH:MM format");
//       return;
//     }

//     const fromCoords = extractCoords(fromLocation.raw);
//     const toCoords   = extractCoords(toLocation.raw);
//     if (!fromCoords) { toast.error("From location coordinates are missing."); return; }
//     if (!toCoords)   { toast.error("To location coordinates are missing."); return; }

//     setIsSubmitting(true);
//     try {
//       const bookingDateTime = formatDateTime(selectedDate, bsTime);
//       console.log("[AdvancedBookingForm] Scheduled booking date time:", bookingDateTime);
      
//       // Check if selected time is in the future
//       const selectedTime = new Date(bookingDateTime);
//       const now = new Date();
//       if (selectedTime <= now) {
//         toast.warning("Selected time is in the past. Booking will be sent immediately.");
//       }
      
//       const payload = [{
//         bId: "",
//         vId: selectedVehicle.vehicleId,
//         dSNo: selectedVehicle.driverSno,
//         slatitude:  fromCoords.lat,
//         slongitude: fromCoords.lng,
//         elatitude:  toCoords.lat,
//         elongitude: toCoords.lng,
//         status: "P",
//         bookingDT: bookingDateTime,
//         bsTime: bookingDateTime, // Scheduled start time
//         beTime: null,
//         totalDestence: "0",
//         dlongitude: String(driverLocation?.lng || fromCoords.lng),
//         dlatitude:  String(driverLocation?.lat || fromCoords.lat),
//         bookingSno: userDetails?.ServiceNo || "",
//         WorkArea: null, WorkScope: null, Priority: null,
//         From: fromLocation.value,
//         TO:   toLocation.value,
//         Remark: "",
//         SubBook: "I",
//         BookingStatus: "S", // S = Scheduled Booking (not real-time)
//       }];

//       console.log("[AdvancedBookingForm] 📤 Sending booking payload:", JSON.stringify(payload, null, 2));

//       const res = await api.post("/BookingRegister/PostForkBooking", payload);
      
//       if (res.status === 200) {
//         const { bookingForAlert, actualBookingId } = await processBookingResponse(res.data, payload, bookingDateTime);
       
//         console.log("[AdvancedBookingForm] Actual bId from API:", actualBookingId);
        
//         let driverName = selectedVehicle.driverName || selectedVehicle.driverSno || "Driver";
//         try {
//           const usersRes = await api.get("/User/GetUsers");
//           const users = usersRes.data?.resultSet || usersRes.data || [];
//           const driver = users.find(u => u.ServiceNo === selectedVehicle.driverSno);
//           if (driver?.Name) driverName = driver.Name;
//         } catch (err) {
//           console.warn("Failed to fetch driver name:", err);
//         }
        
//         setSubmittedBooking({
//           ...bookingForAlert,
//           vehicleType: "Forklift",
//           driverName: driverName,
//           weightCat: selectedWeight,
//           distance: "0",
//           bookingTime: bookingDateTime,
//           scheduledFor: bookingDateTime,
//         });
        
//         setShowBookingOverlay(true);
//         toast.success(`Forklift booking scheduled for ${bookingDateTime}! Driver will be notified at that time.`);
        
//         if (onBookingCreated) await onBookingCreated();
        
//         setTimeout(() => {
//           setShowBookingOverlay(false);
//           if (onClose) onClose();
//         }, 3000);
//       }
//     } catch (err) {
//       console.error("[AdvancedBookingForm] Booking failed:", err);
//       toast.error("Failed to create booking. Please try again.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };
  
//   // ── step visibility ───────────────────────────────────────────────────────

//   const showStep2 = !!selectedWeight;
//   const showStep3 = showStep2 && !!fromLocation && !!toLocation;
//   const showStep4 = showStep3 && !!selectedVehicle;

//   const selectPortalStyles = {
//     menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//     menu:       (base) => ({ ...base, zIndex: 9999 }),
//   };

//   // ─────────────────────────────────────────────────────────────────────────

//   return (
//     <>
//       <div className="w-full bg-gradient-to-br from-white to-blue-50 rounded-2xl shadow-xl p-6 md:p-8">
//         {/* Header */}
//         <div className="flex justify-between items-center mb-6">
//           <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
//             Create Forklift Booking
//           </h2>
//           {onClose && (
//             <button
//               onClick={onClose}
//               className="text-gray-400 hover:text-gray-600 transition"
//             >
//               <X size={28} />
//             </button>
//           )}
//         </div>

//         <form onSubmit={handleSubmit} className="space-y-6">

//           {/* ── STEP 1: Weight Category ── */}
//           <div className="space-y-3">
//             <div className="flex items-center gap-3">
//               <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white font-bold text-sm">
//                 1
//               </div>
//               <h3 className="text-lg font-semibold text-gray-800">
//                 Select Weight Category
//               </h3>
//             </div>

//             {loadingWeights || loadingVehicles ? (
//               <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl">
//                 <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600" />
//                 <span className="text-gray-600 text-sm">Loading weight categories...</span>
//               </div>
//             ) : weightOptions.length === 0 ? (
//               <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg text-yellow-700 text-sm">
//                 No weight categories available. Please check vehicle data.
//               </div>
//             ) : (
//               <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2">
//                 {weightOptions.map((opt) => {
//                   const count = forkliftVehicles.filter(
//                     (v) => v.weightCat === opt.value && v.oStatus === "Online"
//                   ).length;
//                   const active = selectedWeight === opt.value;
//                   return (
//                     <button
//                       key={opt.value}
//                       type="button"
//                       disabled={count === 0}
//                       onClick={() => {
//                         setSelectedWeight(opt.value);
//                         setFromLocation(null);
//                         setToLocation(null);
//                         setSuggestedVehicles([]);
//                         setSelectedVehicle(null);
//                       }}
//                       className={`relative flex flex-col items-center justify-center p-3 rounded-xl border-2 font-semibold text-sm transition
//                         ${
//                           count === 0
//                             ? "opacity-40 cursor-not-allowed bg-gray-100 border-gray-200 text-gray-400"
//                             : active
//                             ? `${opt.color} ring-2 ring-offset-1 ring-blue-500 shadow-md scale-105`
//                             : `${opt.color} hover:scale-105 hover:shadow cursor-pointer`
//                         }`}
//                     >
//                       <Truck size={20} className="mb-1" />
//                       {opt.label}
//                       <span className={`text-xs mt-1 font-normal ${count === 0 ? "text-gray-400" : "opacity-70"}`}>
//                         {count} available
//                       </span>
//                       {active && (
//                         <CheckCircle
//                           size={14}
//                           className="absolute top-1 right-1 text-blue-600"
//                         />
//                       )}
//                     </button>
//                   );
//                 })}
//               </div>
//             )}
//           </div>

//           {/* ── STEP 2: Locations ── */}
//           {showStep2 && (
//             <div className="space-y-4 pt-4 border-t border-gray-200">
//               <div className="flex items-center gap-3">
//                 <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white font-bold text-sm">
//                   2
//                 </div>
//                 <h3 className="text-lg font-semibold text-gray-800">
//                   Select Locations
//                 </h3>
//               </div>

//               {loadingWorkAreas ? (
//                 <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl">
//                   <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600" />
//                   <span className="text-gray-600 text-sm">Loading locations...</span>
//                 </div>
//               ) : (
//                 <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
//                   {/* From */}
//                   <div>
//                     <label className="block text-gray-800 font-bold mb-2 flex items-center gap-2 text-sm">
//                       <MapPin className="text-green-600" size={18} />
//                       From Location <span className="text-red-500">*</span>
//                     </label>
//                     <Select
//                       options={locationOptions}
//                       value={fromLocation}
//                       onChange={(opt) => {
//                         setFromLocation(opt);
//                         setSelectedVehicle(null);
//                         if (toLocation && opt?.value === toLocation.value) {
//                           setToLocation(null);
//                         }
//                       }}
//                       placeholder="Select starting location..."
//                       isClearable
//                       isSearchable
//                       menuPortalTarget={document.body}
//                       styles={selectPortalStyles}
//                     />
//                     {fromLocation && (
//                       <p className="text-xs text-green-600 mt-1">
//                         ✓ {fromLocation.label}
//                       </p>
//                     )}
//                   </div>

//                   {/* To */}
//                   <div>
//                     <label className="block text-gray-800 font-bold mb-2 flex items-center gap-2 text-sm">
//                       <MapPin className="text-blue-600" size={18} />
//                       To Location <span className="text-red-500">*</span>
//                     </label>
//                     <Select
//                       options={locationOptions.filter(
//                         (o) => o.value !== fromLocation?.value
//                       )}
//                       value={toLocation}
//                       onChange={(opt) => {
//                         setToLocation(opt);
//                         setSelectedVehicle(null);
//                       }}
//                       placeholder="Select destination..."
//                       isClearable
//                       isSearchable
//                       menuPortalTarget={document.body}
//                       styles={selectPortalStyles}
//                     />
//                     {toLocation && (
//                       <p className="text-xs text-blue-600 mt-1">
//                         ✓ {toLocation.label}
//                       </p>
//                     )}
//                   </div>
//                 </div>
//               )}

//               {fromLocation && toLocation && (
//                 <div className="flex items-center justify-center gap-3 p-3 bg-blue-50 rounded-lg text-sm font-semibold text-gray-700">
//                   <span>{fromLocation.label}</span>
//                   <ArrowRight className="text-blue-600" size={18} />
//                   <span>{toLocation.label}</span>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* ── STEP 3: Suggested Vehicle ── */}
//           {showStep3 && (
//             <div className="space-y-3 pt-4 border-t border-gray-200">
//               <div className="flex items-center gap-3">
//                 <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white font-bold text-sm">
//                   3
//                 </div>
//                 <h3 className="text-lg font-semibold text-gray-800">
//                   Suggested Forklift
//                 </h3>
//               </div>

//               {suggestedVehicles.length === 0 ? (
//                 <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg text-yellow-700 text-sm">
//                   No <strong>{selectedWeight}</strong> forklift available online. Please
//                   choose a different weight category.
//                 </div>
//               ) : (
//                 <>
//                   <p className="text-xs text-gray-500">
//                     Showing the best available <strong>{selectedWeight}</strong> forklift 
//                     closest to <strong>{fromLocation?.label}</strong>
//                   </p>
//                   <div className="space-y-2">
//                     {(() => {
//                       const v = suggestedVehicles[0];
//                       const isSelected = selectedVehicle?.vehicleId === v.vehicleId;
//                       const vLat = parseFloat(
//                         v.latitude || v.lat || v.currentLat || 0
//                       );
//                       const vLng = parseFloat(
//                         v.longitude || v.lng || v.currentLng || 0
//                       );
//                       const dist =
//                         fromLocation?.lat && fromLocation?.lng && vLat && vLng
//                           ? haversineKm(
//                               fromLocation.lat,
//                               fromLocation.lng,
//                               vLat,
//                               vLng
//                             ).toFixed(1)
//                           : null;

//                       return (
//                         <button
//                           key={v.vehicleId}
//                           type="button"
//                           onClick={() => setSelectedVehicle(v)}
//                           className={`w-full flex items-center justify-between p-4 rounded-xl border-2 text-left transition
//                             ${
//                               isSelected
//                                 ? "border-green-500 bg-green-50 ring-2 ring-green-300"
//                                 : "border-gray-200 bg-white hover:border-blue-300 hover:bg-blue-50"
//                             }`}
//                         >
//                           <div className="flex items-center gap-3">
//                             <div className="w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm bg-amber-400 text-white">
//                               ★
//                             </div>
//                             <div>
//                               <p className="font-semibold text-gray-800">
//                                 {v.vehicleId}
//                               </p>
//                               <p className="text-xs text-gray-500">
//                                 {v.weightCat} · Driver: {v.driverSno}
//                                 {dist ? ` · ~${dist} km away` : ""}
//                               </p>
//                             </div>
//                           </div>
//                           <div className="flex items-center gap-2">
//                             <span
//                               className={`text-xs px-2 py-0.5 rounded-full font-medium
//                               ${
//                                 v.oStatus === "Online"
//                                   ? "bg-green-100 text-green-700"
//                                   : "bg-gray-100 text-gray-500"
//                               }`}
//                             >
//                               {v.oStatus || v.status || "Available"}
//                             </span>
//                             {isSelected && (
//                               <CheckCircle size={18} className="text-green-600" />
//                             )}
//                           </div>
//                         </button>
//                       );
//                     })()}
//                   </div>
//                 </>
//               )}
//             </div>
//           )}

//           {/* ── STEP 4: Schedule Booking ── */}
//           {showStep4 && (
//             <div className="space-y-4 pt-4 border-t border-gray-200">
//               <div className="flex items-center gap-3">
//                 <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white font-bold text-sm">
//                   4
//                 </div>
//                 <h3 className="text-lg font-semibold text-gray-800">
//                   Schedule Booking
//                 </h3>
//                 <span className="text-xs bg-yellow-100 text-yellow-700 px-2 py-0.5 rounded-full">
//                   Planned Booking
//                 </span>
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 {/* Date Field */}
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
//                     <CalendarIcon className="text-blue-600" size={18} />
//                     Booking Date <span className="text-red-500">*</span>
//                   </label>
//                   <input
//                     type="date"
//                     value={selectedDate}
//                     onChange={(e) => setSelectedDate(e.target.value)}
//                     min={todayStr}
//                     readOnly
//                     className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-600 focus:outline-none"
//                   />
//                 </div>

//                 {/* Time Field - Using CustomTimePicker */}
//                 <div>
//                   <CustomTimePicker
//                     label="Start Time"
//                     value={bsTime}
//                     onChange={handleTimeChange}
//                     required={true}
//                     error={timeError}
//                     placeholder="HH:MM"
//                   />
                   
//                 </div>
//               </div>

//               {/* Info message about scheduled booking */}
//               <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
//                 <p className="text-xs text-blue-700 flex items-center gap-2">
//                   <CalendarIcon size={14} />
//                   This is a <strong>scheduled/planned booking</strong>. The driver will receive an alert only at the selected start time, not immediately.
//                 </p>
//               </div>
//             </div>
//           )}

//           {/* ── Summary ── */}
//           {showStep4 && bsTime && (
//             <div className="bg-gradient-to-br from-blue-100 to-indigo-100 p-5 rounded-xl border-2 border-blue-300">
//               <h4 className="font-semibold text-blue-900 mb-3">📋 Booking Summary</h4>
//               <div className="grid grid-cols-2 gap-3 text-sm">
//                 <div>
//                   <span className="text-blue-700 font-medium">Vehicle:</span>
//                   <p className="text-gray-800 font-semibold">
//                     {selectedVehicle.vehicleId}
//                   </p>
//                 </div>
//                 <div>
//                   <span className="text-blue-700 font-medium">Capacity:</span>
//                   <p className="text-gray-800">{selectedVehicle.weightCat}</p>
//                 </div>
//                 <div>
//                   <span className="text-blue-700 font-medium">Driver:</span>
//                   <p className="text-gray-800">{selectedVehicle.driverSno}</p>
//                 </div>
//                 <div>
//                   <span className="text-blue-700 font-medium">Date & Time:</span>
//                   <p className="text-gray-800 font-semibold">
//                     {selectedDate} {bsTime}
//                   </p>
//                 </div>
//                 <div className="col-span-2">
//                   <span className="text-blue-700 font-medium">Route:</span>
//                   <p className="text-gray-800 flex items-center gap-2 flex-wrap">
//                     <span>{fromLocation.label}</span>
//                     <ArrowRight size={14} />
//                     <span>{toLocation.label}</span>
//                   </p>
//                   <p className="text-xs text-gray-500 mt-1">
//                     Codes: {fromLocation.value} → {toLocation.value}
//                   </p>
//                 </div>
//                 <div className="col-span-2 mt-2 pt-2 border-t border-blue-200">
//                   <p className="text-xs text-blue-700 flex items-center gap-1">
//                     <CalendarIcon size={12} />
//                     <strong>Planned Booking:</strong> Driver will be notified on {selectedDate} at {bsTime}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* ── Buttons ── */}
//           <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
//             {onClose && (
//               <button
//                 type="button"
//                 onClick={onClose}
//                 className="px-6 py-3 rounded-lg font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 transition"
//               >
//                 Cancel
//               </button>
//             )}
//             <button
//               type="submit"
//               disabled={
//                 !showStep4 || !bsTime || isSubmitting || timeError
//               }
//               className={`px-8 py-3 rounded-lg font-bold text-white transition
//                 ${
//                   showStep4 && bsTime && !isSubmitting && !timeError
//                     ? "bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 shadow-lg"
//                     : "bg-gray-400 cursor-not-allowed"
//                 }`}
//             >
//               {isSubmitting ? "Creating Booking..." : "Schedule Forklift Booking"}
//             </button>
//           </div>
//         </form>
//       </div>

//       {/* Booking Success Overlay */}
//       {showBookingOverlay && submittedBooking && (
//         <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center px-4 z-50 animate-fadeIn">
//           <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 sm:p-8 relative animate-slideUp">
//             <button
//               onClick={() => {
//                 setShowBookingOverlay(false);
//                 if (onClose) onClose();
//               }}
//               className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition"
//             >
//               <svg
//                 className="w-6 h-6"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth="2"
//                   d="M6 18L18 6M6 6l12 12"
//                 />
//               </svg>
//             </button>

//             <div className="flex justify-center mb-4">
//               <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
//                 <svg
//                   className="w-10 h-10 text-green-600"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                     d="M5 13l4 4L19 7"
//                   />
//                 </svg>
//               </div>
//             </div>

//             <h2 className="text-2xl font-bold text-center text-gray-800 mb-2">
//               Forklift Booking Scheduled!
//             </h2>
//             <p className="text-center text-gray-600 mb-6">
//               Driver will be notified at the scheduled time
//             </p>

//             <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-4 space-y-3 mb-6">
//               <div className="flex justify-between items-center">
//                 <span className="text-sm text-gray-600">Booking ID:</span>
//                 <span className="font-bold text-blue-700">
//                   #{submittedBooking.bId || "Pending"}
//                 </span>
//               </div>
//               <div className="flex justify-between items-center">
//                 <span className="text-sm text-gray-600">Scheduled For:</span>
//                 <span className="font-semibold text-blue-700">
//                   {submittedBooking.scheduledFor || submittedBooking.bookingTime}
//                 </span>
//               </div>
//               <div className="flex justify-between items-center">
//                 <span className="text-sm text-gray-600">Vehicle:</span>
//                 <span className="font-semibold text-gray-800">
//                   {submittedBooking.vehicleType} ({submittedBooking.weightCat})
//                 </span>
//               </div>
//               <div className="flex justify-between items-center">
//                 <span className="text-sm text-gray-600">Driver:</span>
//                 <span className="font-semibold text-gray-800">
//                   {submittedBooking.driverName}
//                 </span>
//               </div>
//               <div className="flex justify-between items-center">
//                 <span className="text-sm text-gray-600">Route:</span>
//                 <span className="font-semibold text-gray-800 text-sm truncate max-w-[200px]">
//                   {submittedBooking.From} → {submittedBooking.TO}
//                 </span>
//               </div>
//             </div>

//             <div className="flex justify-center items-center space-x-2 mb-4">
//               <CalendarIcon size={16} className="text-blue-600" />
//               <span className="text-sm text-gray-500">
//                 Alert will be sent at scheduled time
//               </span>
//             </div>

//             <p className="text-center text-sm text-gray-500">
//               Closing in a moment...
//             </p>
//           </div>
//         </div>
//       )}

//       <style jsx>{`
//         @keyframes fadeIn {
//           from {
//             opacity: 0;
//           }
//           to {
//             opacity: 1;
//           }
//         }
//         @keyframes slideUp {
//           from {
//             transform: translateY(20px);
//             opacity: 0;
//           }
//           to {
//             transform: translateY(0);
//             opacity: 1;
//           }
//         }
//         .animate-fadeIn {
//           animation: fadeIn 0.3s ease-out;
//         }
//         .animate-slideUp {
//           animation: slideUp 0.4s ease-out;
//         }
//       `}</style>
//     </>
//   );
// }




import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Select from "react-select";
import CustomTimePicker from "../components/CustomTimePicker";
import {
  MapPin,
  X,
  Calendar as CalendarIcon,
  ArrowRight,
  Truck,
  CheckCircle,
  Layers,
  Trash2,
  AlertCircle,
} from "lucide-react";
import { getAllWorkAreas } from "../services/workAreaService";
import api from "../services/api";
import bookingWS from "../services/bookingWebSocket";
import { getMainForkBookingDetails } from "../services/bookingService";
import AdminBookingRequestService from "../services/AdminBookingRequestService";
import { reserveVehicle, withAssignmentLock } from "../utils/assignmentLock";

// ─── Resource Types (same 3 as BookingScheduler) ────────────────────────────
const RESOURCE_TYPES = ["Trailer", "Crane", "Trailer and Crane"];

const getResourceTypeCode = (type) => {
  const map = { Trailer: "T", Crane: "C", "Trailer and Crane": "TC" };
  return map[type] || type;
};

const RESOURCE_META = {
  Trailer: {
    icon: "🚛",
    color: "bg-blue-50 border-blue-300 text-blue-800",
    activeColor: "bg-blue-600 border-blue-600 text-white",
    badge: "bg-blue-100 text-blue-700",
  },
  Crane: {
    icon: "🏗️",
    color: "bg-amber-50 border-amber-300 text-amber-800",
    activeColor: "bg-amber-600 border-amber-600 text-white",
    badge: "bg-amber-100 text-amber-700",
  },
  "Trailer and Crane": {
    icon: "🚛🏗️",
    color: "bg-purple-50 border-purple-300 text-purple-800",
    activeColor: "bg-purple-600 border-purple-600 text-white",
    badge: "bg-purple-100 text-purple-700",
  },
};

// ─── helpers ─────────────────────────────────────────────────────────────────
const formatDate = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

const formatDateTime = (date, time) => `${date} ${time}:00`;

// Default job length used to prefill the end time when the supervisor does not
// change it.
const DEFAULT_DURATION_MIN = 30;

// "2026-08-17 23:45:00" + 30 -> "2026-08-18 00:15:00"
// Built from a real Date object so the midnight rollover is handled correctly.
const addMinutesToDateTime = (dateTimeStr, minutes) => {
  const d = new Date(String(dateTimeStr).replace(" ", "T"));
  if (isNaN(d.getTime())) return null;
  d.setMinutes(d.getMinutes() + minutes);
  const pad = (n) => String(n).padStart(2, "0");
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
    `${pad(d.getHours())}:${pad(d.getMinutes())}:00`
  );
};

// "14:45" + 30 -> "15:15"   (used to prefill the End Time picker)
const addMinutesToTime = (time, minutes) => {
  const [h, m] = String(time).split(":").map(Number);
  if (isNaN(h) || isNaN(m)) return "";
  const d = new Date();
  d.setHours(h, m + minutes, 0, 0);
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};

const haversineKm = (lat1, lng1, lat2, lng2) => {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

const extractCoords = (raw) => {
  if (!raw) return null;
  const pick = (obj, keys) => {
    for (const k of keys) {
      if (obj[k] !== undefined && obj[k] !== null && obj[k] !== "") {
        const n = parseFloat(obj[k]);
        if (!Number.isNaN(n)) return n;
      }
    }
    return null;
  };
  const latKeys = [
    "latitude","Latitude","lat","LAT","Lat","LatitudeValue",
    "WALatitude","WA_Latitude","WA_latitude","WaLatitude","WALat",
    "WorkAreaLatitude","workAreaLatitude","work_area_latitude",
  ];
  const lngKeys = [
    "longitude","Longitude","lng","LNG","Long","LongitudeValue",
    "WALongitude","WA_Longitude","WA_longitude","WaLongitude","WALong",
    "WorkAreaLongitude","workAreaLongitude","work_area_longitude",
  ];
  let latNum = pick(raw, latKeys);
  let lngNum = pick(raw, lngKeys);
  if (latNum === null || lngNum === null) {
    const keys = Object.keys(raw || {});
    const lk = keys.find((k) => k.toLowerCase().includes("lat"));
    const nk = keys.find(
      (k) =>
        k.toLowerCase().includes("lon") ||
        k.toLowerCase().includes("lng") ||
        k.toLowerCase().includes("long")
    );
    if (latNum === null && lk) { const n = parseFloat(raw[lk]); if (!isNaN(n)) latNum = n; }
    if (lngNum === null && nk) { const n = parseFloat(raw[nk]); if (!isNaN(n)) lngNum = n; }
  }
  if (latNum === null || lngNum === null) return null;
  return { lat: latNum.toFixed(6), lng: lngNum.toFixed(6) };
};

// ─── component ───────────────────────────────────────────────────────────────
export default function AdvancedBookingForm({ onBookingCreated, onClose }) {
  const { userDetails, authKey } = useSelector((s) => s.auth);

  const now = new Date();
  const todayStr = formatDate(now);

  const getCurrentTime = () => {
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };
  const currentTime = getCurrentTime();

  // ── state ─────────────────────────────────────────────────────────────────
  const [selectedWeight, setSelectedWeight] = useState("");
  const [weightOptions, setWeightOptions] = useState([]);
  const [loadingWeights, setLoadingWeights] = useState(false);
  const [forkliftVehicles, setForkliftVehicles] = useState([]);
  const [loadingVehicles, setLoadingVehicles] = useState(false);
  const [workAreas, setWorkAreas] = useState([]);
  const [loadingWorkAreas, setLoadingWorkAreas] = useState(false);
  const [driverLocation, setDriverLocation] = useState(null);

  const [fromLocation, setFromLocation] = useState(null);
  const [toLocation, setToLocation] = useState(null);
  const [suggestedVehicles, setSuggestedVehicles] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectedDate, setSelectedDate] = useState(todayStr);
  const [bsTime, setBsTime] = useState(currentTime);
  const [beTime, setBeTime] = useState(addMinutesToTime(currentTime, DEFAULT_DURATION_MIN));
  const [timeError, setTimeError] = useState("");
  const [endTimeError, setEndTimeError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // TC-02 - forklifts that failed the confirm-time re-check for THIS booking.
  // Without this the ranking re-runs, the same forklift is still closest, and it
  // gets suggested again forever.
  const [rejectedVehicleIds, setRejectedVehicleIds] = useState([]);
  const [conflictNotice, setConflictNotice] = useState(null);

  // Bring the bookings via getMainForkBookingsDetails and store them to check for driver availability
  const [existingBookings, setExistingBookings] = useState([]);

  // ── NEW: Resource state ───────────────────────────────────────────────────
  const [needsResources, setNeedsResources] = useState(false);
  const [assignedResources, setAssignedResources] = useState([]);

  // ── Success overlay ───────────────────────────────────────────────────────
  const [showBookingOverlay, setShowBookingOverlay] = useState(false);
  const [submittedBooking, setSubmittedBooking] = useState(null);

  // ── WebSocket ─────────────────────────────────────────────────────────────
  useEffect(() => {
    if (authKey) {
      bookingWS.connectAsEmployee(authKey);
    }
  }, [authKey]);

  // ── Fetch weight categories ───────────────────────────────────────────────
  useEffect(() => {
    const fetchWeightCategories = async () => {
      setLoadingWeights(true);
      try {
        const res = await api.get("/VehicleDetails/GetVehicleDetails");
        let data =
          res.data?.resultSet ??
          res.data?.data ??
          (Array.isArray(res.data) ? res.data : []);
        const forklifts = data.filter(
          (v) => v.vehicleType?.toLowerCase() === "forklift"
        );
        const uniqueWeights = [
          ...new Set(forklifts.map((v) => v.weightCat).filter((w) => w)),
        ];
        const sortOrder = ["3T","5T","7T","10T","15T","20T","25T","30T"];
        const sortedWeights = uniqueWeights.sort((a, b) => {
          const ai = sortOrder.indexOf(a), bi = sortOrder.indexOf(b);
          if (ai !== -1 && bi !== -1) return ai - bi;
          if (ai !== -1) return -1;
          if (bi !== -1) return 1;
          return a.localeCompare(b);
        });
        const colorMap = {
          "3T": "bg-blue-100 text-blue-700 border-blue-300",
          "5T": "bg-green-100 text-green-700 border-green-300",
          "7T": "bg-yellow-100 text-yellow-700 border-yellow-300",
          "10T": "bg-orange-100 text-orange-700 border-orange-300",
          "15T": "bg-red-100 text-red-700 border-red-300",
          "20T": "bg-gray-200 text-gray-700 border-gray-400",
          "25T": "bg-purple-100 text-purple-700 border-purple-300",
          "30T": "bg-pink-100 text-pink-700 border-pink-300",
        };
        setWeightOptions(
          sortedWeights.map((weight) => ({
            value: weight,
            label: weight,
            color: colorMap[weight] || "bg-gray-100 text-gray-700 border-gray-300",
          }))
        );
      } catch (error) {
        toast.error("Failed to load weight categories");
      } finally {
        setLoadingWeights(false);
      }
    };
    fetchWeightCategories();
  }, []);

  // ── Fetch forklift vehicles ───────────────────────────────────────────────
  useEffect(() => {
    (async () => {
      setLoadingVehicles(true);
      try {
        const res = await api.get("/VehicleDetails/GetVehicleDetails");
        let data =
          res.data?.resultSet ??
          res.data?.data ??
          (Array.isArray(res.data) ? res.data : []);
        setForkliftVehicles(
          data.filter(
            (v) =>
              v.vehicleType?.toLowerCase() === "forklift" &&
              v.status?.toLowerCase() === "active"
          )
        );
      } catch {
        toast.error("Failed to load forklift vehicles");
      } finally {
        setLoadingVehicles(false);
      }
    })();
  }, []);

  // ── Fetch work areas ──────────────────────────────────────────────────────
  useEffect(() => {
    (async () => {
      setLoadingWorkAreas(true);
      try {
        const data = await getAllWorkAreas();
        setWorkAreas(
          data.map((item) => ({
            WAcode: item.WAcode || item.code || item.waCode,
            WAname: item.WAname || item.name || item.waName,
            status: item.status || item.Status,
            raw: item,
          }))
        );
      } catch {
        toast.error("Failed to load locations");
      } finally {
        setLoadingWorkAreas(false);
      }
    })();
  }, []);

  // Fetch existing bookings.
  // This used to run ONCE on mount, so a supervisor who left the form open for
  // two minutes was ranking forklifts against a two-minute-old picture of the
  // world - the core of TC-02. Refresh on a timer so the suggestion stays live.
  useEffect(() => {
    let cancelled = false;

    const loadBookings = async () => {
      try {
        const data = await getMainForkBookingDetails();
        if (!cancelled) setExistingBookings(data || []);
      } catch (loadBookingErr) {
        console.error("Failed to load booking details: ", loadBookingErr);
      }
    };

    loadBookings();
    const intervalId = setInterval(loadBookings, 15000);

    return () => {
      cancelled = true;
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    navigator.geolocation?.getCurrentPosition(
      (p) =>
        setDriverLocation({ lat: p.coords.latitude, lng: p.coords.longitude }),
      () => {}
    );
  }, []);

  // ── Location options ──────────────────────────────────────────────────────
  const locationOptions = useMemo(() => {
    return workAreas
      .filter((w) => {
        const s = String(w.status || "").trim().toLowerCase();
        return ["active", "a", "1", "true", "yes"].includes(s);
      })
      .map((w) => {
        const coords = extractCoords(w.raw);
        return {
          value: w.WAcode,
          label: w.WAname,
          raw: w.raw,
          lat: coords ? parseFloat(coords.lat) : null,
          lng: coords ? parseFloat(coords.lng) : null,
        };
      });
  }, [workAreas]);

  // Helper functions needed for check overlaps for driver availability
  // Match on the VEHICLE, not the driver. A driver can be swapped between
  // vehicles, and a booking row with a blank driverSno silently matched
  // everything before this change.
  const hasTimeConflict = (vehicleId, newStart, newEnd) => {
    const vId = String(vehicleId || "").trim();
    if (!vId) return true; // no id = cannot prove it is free, so treat as busy

    return existingBookings.some((booking) => {
      if (String(booking.vId || "").trim() !== vId) return false;

      // A cancelled or completed booking must NOT block the slot.
      const status = String(booking.status || "").toLowerCase();
      if (status === "completed" || status === "cancel" || status === "cancelled") return false;

      if (!booking.bsTime) return false;

      const existingStart = new Date(booking.bsTime);
      const existingEnd = booking.beTime
        ? new Date(booking.beTime)
        : new Date(existingStart.getTime() + DEFAULT_DURATION_MIN * 60 * 1000);

      // Half-open overlap: a job ending exactly when the next starts is fine.
      return newStart < existingEnd && newEnd > existingStart;
    });
  };

  // ── Auto-suggest vehicle ──────────────────────────────────────────────────
  useEffect(() => {
    if (!selectedWeight || !fromLocation || !toLocation || !selectedDate || !bsTime) {
      setSuggestedVehicles([]);
      setSelectedVehicle(null);
      return;
    }


    // Older logic which only selected the exact weight match
    // const weightMatched = forkliftVehicles.filter(
    //   (v) => v.weightCat === selectedWeight && v.oStatus === "Online"
    // );
    // if (weightMatched.length === 0) {
    //   setSuggestedVehicles([]);
    //   setSelectedVehicle(null);
    //   return;
    // }

    // Booking window - now driven by the end time the supervisor entered, which
    // is also what gets written to the database.
    const bookingStart = new Date(formatDateTime(selectedDate, bsTime).replace(" ", "T"));
    const bookingEnd = new Date(formatDateTime(selectedDate, beTime).replace(" ", "T"));
    if (bookingEnd <= bookingStart) bookingEnd.setDate(bookingEnd.getDate() + 1);

    // method to convert 5T -> 5
    const getWeightValue = (weight) => parseInt(String(weight).replace(/[^\d]/g, ""), 10);

    // Only select online vehicles with available drivers
    const rejected = new Set(rejectedVehicleIds.map((id) => String(id).trim()));

    const availableVehicles = forkliftVehicles.filter((vehicle) => {
      if (vehicle.oStatus !== "Online") return false;
      // TC-02 - already failed the confirm-time re-check for this booking
      if (rejected.has(String(vehicle.vehicleId).trim())) return false;

      return !hasTimeConflict(vehicle.vehicleId, bookingStart, bookingEnd);
    });

    if (availableVehicles.length === 0) {
      setSuggestedVehicles([]);
      setSelectedVehicle(null);
      return;
    }

    const requestedWeight = getWeightValue(selectedWeight);

    // Find the lowest available weight >= requested weight
    const availableWeights = [
      ...new Set(availableVehicles.map((v) => v.weightCat).filter(Boolean))
    ].sort(
      (a, b) => getWeightValue(a) - getWeightValue(b)
    );

    let candidateVehicles = [];

    for (const weight of availableWeights) {
      if (getWeightValue(weight) < requestedWeight) continue;

      const matches = availableVehicles.filter(
        (v) => v.weightCat === weight
      );

      if (matches.length > 0) {
        candidateVehicles = matches;
        break;
      }
    }

    // No suitable weight found
    if (candidateVehicles.length === 0) {
      setSuggestedVehicles([]);
      setSelectedVehicle(null);
      return;
    }

    // Sort by distance from pickup location
    const fromLat = fromLocation.lat;
    const fromLng = fromLocation.lng;
    const sorted = [...candidateVehicles].sort((a, b) => {
      if (!fromLat || !fromLng) return 0;
      const aLat = parseFloat(a.latitude || a.lat || a.currentLat || 0);
      const aLng = parseFloat(a.longitude || a.lng || a.currentLng || 0);
      const bLat = parseFloat(b.latitude || b.lat || b.currentLat || 0);
      const bLng = parseFloat(b.longitude || b.lng || b.currentLng || 0);
      const da = aLat && aLng ? haversineKm(fromLat, fromLng, aLat, aLng) : 9999;
      const db = bLat && bLng ? haversineKm(fromLat, fromLng, bLat, bLng) : 9999;
      return da - db;
    });
    setSuggestedVehicles(sorted);
    setSelectedVehicle(sorted[0]);
  }, [selectedWeight, fromLocation, toLocation, selectedDate, bsTime, beTime,
      forkliftVehicles, existingBookings, rejectedVehicleIds]);

  // ── Time validation ───────────────────────────────────────────────────────
  const validateTime = (time) => {
    if (!/^([0-1]?\d|2[0-3]):[0-5]\d$/.test(time)) {
      setTimeError("Invalid time format. Please use HH:MM");
      return false;
    }
    setTimeError("");
    return true;
  };

  // End must parse AND be after start. We compare full date-times so a job that
  // legitimately crosses midnight (23:45 -> 00:15) is still accepted.
  const validateEndTime = (endValue, startValue = bsTime) => {
    if (!/^([0-1]?\d|2[0-3]):[0-5]\d$/.test(endValue)) {
      setEndTimeError("Invalid time format. Please use HH:MM");
      return false;
    }
    const start = new Date(formatDateTime(selectedDate, startValue).replace(" ", "T"));
    const end = new Date(formatDateTime(selectedDate, endValue).replace(" ", "T"));
    if (end <= start) end.setDate(end.getDate() + 1); // crosses midnight
    const minutes = (end - start) / 60000;
    if (minutes > 12 * 60) {
      setEndTimeError("End time must be within 12 hours of the start time");
      return false;
    }
    setEndTimeError("");
    return true;
  };

  const handleTimeChange = (newTime) => {
    setBsTime(newTime);
    validateTime(newTime);
    // Shift the end time along with the start so the supervisor is not forced to
    // retype it. They can still override it afterwards.
    const shifted = addMinutesToTime(newTime, DEFAULT_DURATION_MIN);
    setBeTime(shifted);
    validateEndTime(shifted, newTime);
    setSelectedVehicle(null);
    setRejectedVehicleIds([]);
    setConflictNotice(null);
  };

  const handleEndTimeChange = (newTime) => {
    setBeTime(newTime);
    validateEndTime(newTime);
    setSelectedVehicle(null);
    setRejectedVehicleIds([]);
    setConflictNotice(null);
  };

  // ── NEW: Resource handlers ────────────────────────────────────────────────
  const handleAddResource = (type) => {
    if (assignedResources.length > 0) {
      const existing = assignedResources[0];
      if (existing.type === type) {
        // Toggle off
        setAssignedResources([]);
        return;
      }
      // Switch to new type
    }
    const code = getResourceTypeCode(type);
    setAssignedResources([
      {
        id: `${Date.now()}`,
        type,
        vehicleCode: code,
        startTime: bsTime,
        endTime: bsTime,
        from: fromLocation?.value || "",
        fromName: fromLocation?.label || "",
        to: toLocation?.value || "",
        toName: toLocation?.label || "",
      },
    ]);
  };

  const handleRemoveResource = (id) => {
    setAssignedResources(assignedResources.filter((r) => r.id !== id));
  };

  // ── WebSocket helpers ─────────────────────────────────────────────────────
  const scheduleWebSocketNotification = (bookingData, scheduledDateTime) => {
    const scheduledTime = new Date(scheduledDateTime);
    const delayMs = scheduledTime.getTime() - Date.now();
    if (delayMs <= 0) {
      _doSendWS(bookingData, scheduledDateTime);
      return;
    }
    setTimeout(() => {
      _doSendWS(bookingData, scheduledDateTime);
    }, delayMs);
    toast.info(`📅 Booking scheduled for ${scheduledDateTime}. Driver will be notified at that time.`);
  };

  const _doSendWS = (bookingData, scheduledDateTime, retryCount = 0) => {
    if (bookingWS.isReady()) {
      const wsPayload = {
        ...bookingData,
        type: "new_booking",
        action: "create_booking",
        timestamp: new Date().toISOString(),
        bookingTime: scheduledDateTime,
        BookingStatus: "S",
        isScheduled: true,
        scheduledFor: scheduledDateTime,
      };
      bookingWS.sendBooking(wsPayload);
    } else if (retryCount < 3) {
      setTimeout(() => _doSendWS(bookingData, scheduledDateTime, retryCount + 1), 1000 * (retryCount + 1));
    } else {
      toast.error("Failed to send alert to driver.");
    }
  };

  const processBookingResponse = async (responseData, payload, bookingDateTime, bookingEndDateTime = null) => {
    let actualBookingId =
      responseData?.resultSet?.[0]?.bId ||
      responseData?.result?.bId ||
      responseData?.bId ||
      responseData?.id ||
      null;

    if (!actualBookingId) {
      try {
        const bookingsRes = await api.get("/BookingDetails/GetBookingDetails");
        const allBookings = bookingsRes.data?.resultSet || [];
        const matched = allBookings
          .filter(
            (b) =>
              b.vId === payload[0].vId &&
              b.dSNo === payload[0].dSNo &&
              (b.status === "P" || b.status === "Pending")
          )
          .sort((a, b) => parseInt(b.bId) - parseInt(a.bId))[0];
        if (matched?.bId) actualBookingId = matched.bId;
      } catch (err) {}
    }

    const bookingForAlert = {
      bId: actualBookingId,
      vId: payload[0].vId,
      dSNo: payload[0].dSNo,
      employeeName: userDetails?.Name || "Employee",
      slatitude: payload[0].slatitude,
      slongitude: payload[0].slongitude,
      elatitude: payload[0].elatitude,
      elongitude: payload[0].elongitude,
      totalDestence: "0",
      bookingDT: bookingDateTime,
      bsTime: bookingDateTime,
      beTime: bookingEndDateTime,
      status: "P",
      bookingSno: userDetails?.ServiceNo || "",
      dlatitude: payload[0].dlatitude,
      dlongitude: payload[0].dlongitude,
      From: payload[0].From,
      TO: payload[0].TO,
      vehicleType: "Forklift",
      weightCat: selectedWeight,
      BookingStatus: "S",
      isScheduled: true,
    };

    if (bookingDateTime) {
      scheduleWebSocketNotification(bookingForAlert, bookingDateTime);
    }
    return { actualBookingId, bookingForAlert };
  };

  // ── Submit ────────────────────────────────────────────────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedWeight) { toast.error("Please select weight category."); return; }
    if (!fromLocation)   { toast.error("Please select From location."); return; }
    if (!toLocation)     { toast.error("Please select To location."); return; }
    if (fromLocation.value === toLocation.value) {
      toast.error("From and To locations cannot be the same.");
      return;
    }
    if (!selectedVehicle) { toast.error("No vehicle available for this selection."); return; }
    if (!bsTime)          { toast.error("Please select start time."); return; }
    if (!beTime)          { toast.error("Please select estimated end time."); return; }
    if (!validateTime(bsTime)) { toast.error("Please enter a valid start time in HH:MM format"); return; }
    if (!validateEndTime(beTime)) { toast.error(endTimeError || "Please enter a valid end time"); return; }

    // Resource validation
    if (needsResources && assignedResources.length === 0) {
      toast.error("Please select a resource type or uncheck 'Need additional resources'.");
      return;
    }

    const fromCoords = extractCoords(fromLocation.raw);
    const toCoords   = extractCoords(toLocation.raw);
    if (!fromCoords) { toast.error("From location coordinates are missing."); return; }
    if (!toCoords)   { toast.error("To location coordinates are missing."); return; }

    setIsSubmitting(true);
    // Hoisted so the catch block below can release it on any failure path.
    let claimed = null;
    try {
      const bookingDateTime = formatDateTime(selectedDate, bsTime);
      const selectedTime = new Date(bookingDateTime.replace(" ", "T"));

      // -- Real end time, written to the database ---------------------------
      // Previously this posted beTime: null. Because the backend overlap check
      // is "... BETWEEN booking_start_time AND booking_end_time", a NULL end
      // time meant unplanned bookings were INVISIBLE to every availability
      // query in the system - no other booking could ever see them.
      let bookingEndDateTime = formatDateTime(selectedDate, beTime);
      if (new Date(bookingEndDateTime.replace(" ", "T")) <= selectedTime) {
        // crosses midnight - roll the end date to the next day
        const rolled = new Date(bookingEndDateTime.replace(" ", "T"));
        rolled.setDate(rolled.getDate() + 1);
        const pad = (n) => String(n).padStart(2, "0");
        bookingEndDateTime =
          `${rolled.getFullYear()}-${pad(rolled.getMonth() + 1)}-${pad(rolled.getDate())} ` +
          `${pad(rolled.getHours())}:${pad(rolled.getMinutes())}:00`;
      }

      // -- TC-02: confirm-time availability re-check ------------------------
      // The suggestion was made while the supervisor was still filling the
      // form. Between then and this click another supervisor may have taken the
      // same forklift. Ask the server again, right now, and walk down the
      // ranked list until one is both free and successfully claimed.
      claimed = await withAssignmentLock(async () => {
        const candidates = suggestedVehicles.length ? suggestedVehicles : [selectedVehicle];

        for (const candidate of candidates) {
          if (rejectedVehicleIds.includes(String(candidate.vehicleId).trim())) continue;

          let isBusy = false;
          try {
            const checkRes = await AdminBookingRequestService.GetVehicleAlreadyInfo(
              candidate.vehicleId,
              bookingDateTime,
              bookingEndDateTime
            );
            isBusy = String(checkRes.data?.result || "").toLowerCase() === "true";
          } catch (checkErr) {
            // Assume free on API error - matches the rest of the codebase and
            // avoids blocking every booking when this endpoint is flaky.
            console.error(
              "[Unplanned] availability re-check failed for",
              candidate.vehicleId,
              checkErr.message
            );
          }

          if (isBusy) continue;

          const claim = reserveVehicle(
            candidate.vehicleId,
            bookingDateTime,
            bookingEndDateTime,
            ""
          );
          if (claim) return { vehicle: candidate, claim };
        }
        return null;
      });

      if (!claimed) {
        setConflictNotice(
          `Every suitable forklift is already assigned between ${bsTime} and ${beTime}. Try a different time slot.`
        );
        toast.error("No forklift is free for this time slot.");
        setIsSubmitting(false);
        return;
      }

      // A different forklift than the one on screen? Tell the supervisor what
      // changed and make them press again, so they confirm what they are getting.
      if (String(claimed.vehicle.vehicleId) !== String(selectedVehicle.vehicleId)) {
        claimed.claim.release();
        const takenId = String(selectedVehicle.vehicleId).trim();
        claimed = null;
        setRejectedVehicleIds((prev) => [...prev, takenId]);
        setConflictNotice(
          `${takenId} was just assigned to another booking. Press again to confirm the next closest forklift.`
        );
        toast.warning(`${takenId} is no longer available - suggesting the next closest forklift`);
        setIsSubmitting(false);
        return;
      }

      setConflictNotice(null);
      // if (selectedTime <= new Date()) {
      //   toast.warning("Selected time is in the past. Booking will be sent immediately.");
      // }

      // Build SubBook value from resources
      let subBookValue = "";
      if (needsResources && assignedResources.length > 0) {
        const codes = assignedResources.map((r) => getResourceTypeCode(r.type));
        subBookValue = codes.join(",");
      }

      const payload = [
        {
          bId: "",
          vId: claimed.vehicle.vehicleId,
          dSNo: claimed.vehicle.driverSno,
          slatitude:  fromCoords.lat,
          slongitude: fromCoords.lng,
          elatitude:  toCoords.lat,
          elongitude: toCoords.lng,
          status: "P",
          bookingDT: bookingDateTime,
          bsTime: bookingDateTime,
          beTime: bookingEndDateTime,
          totalDestence: "0",
          dlongitude: String(driverLocation?.lng || fromCoords.lng),
          dlatitude:  String(driverLocation?.lat || fromCoords.lat),
          bookingSno: userDetails?.ServiceNo || "",
          WorkArea: null,
          WorkScope: null,
          Priority: null,
          From: fromLocation.value,
          TO:   toLocation.value,
          Remark: "",
          // FIXED: SubBook carries resource codes when resources selected
          SubBook: subBookValue,
          BookingStatus: "S",
          tonnage: selectedWeight,
        },
      ];

      const res = await api.post("/BookingRegister/PostForkBooking", payload);

      // Hold the claim briefly past the write. GetVehicleAlreadyInfo is
      // eventually consistent, so releasing instantly would let the very next
      // booking read stale "FREE" data and hand out the same forklift again.
      const settledClaim = claimed;
      claimed = null;
      setTimeout(settledClaim.claim.release, 30000);

      if (res.status === 200) {
        const { bookingForAlert, actualBookingId } = await processBookingResponse(
          res.data,
          payload,
          bookingDateTime,
          bookingEndDateTime
        );

        let driverName =
          settledClaim.vehicle.driverName || settledClaim.vehicle.driverSno || "Driver";
        try {
          const usersRes = await api.get("/User/GetUsers");
          const users = usersRes.data?.resultSet || usersRes.data || [];
          const driver = users.find((u) => u.ServiceNo === settledClaim.vehicle.driverSno);
          if (driver?.Name) driverName = driver.Name;
        } catch {}

        setSubmittedBooking({
          ...bookingForAlert,
          vehicleType: "Forklift",
          driverName,
          weightCat: selectedWeight,
          distance: "0",
          bookingTime: bookingDateTime,
          scheduledFor: bookingDateTime,
          // Include resource info in success overlay
          resourceType: needsResources && assignedResources.length > 0
            ? assignedResources[0].type
            : null,
          resourceCode: needsResources && assignedResources.length > 0
            ? assignedResources[0].vehicleCode
            : null,
        });

        setShowBookingOverlay(true);
        toast.success(
          `Forklift booking scheduled for ${bookingDateTime}!${
            needsResources && assignedResources.length > 0
              ? ` Resource: ${assignedResources[0].type}`
              : ""
          }`
        );

        if (onBookingCreated) await onBookingCreated();

        setTimeout(() => {
          setShowBookingOverlay(false);
          if (onClose) onClose();
        }, 3000);
      }
    } catch (err) {
      // The forklift was never actually taken - never leave it blocked.
      try { claimed?.claim?.release(); } catch (releaseErr) { /* noop */ }
      console.error("[AdvancedBookingForm] Booking failed:", err);
      toast.error("Failed to create booking. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // ── Step visibility ───────────────────────────────────────────────────────
  const showStep2 = !!selectedWeight;
  const showStep3 = showStep2 && !!fromLocation && !!toLocation;
  const showStep4 = showStep3 && !!selectedVehicle;
  const showStep5 = showStep4; // Resources always show after vehicle selected

  const selectPortalStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu:       (base) => ({ ...base, zIndex: 9999 }),
  };

  // ─────────────────────────────────────────────────────────────────────────
  return (
    <>
      <div className="w-full bg-gradient-to-br from-white to-blue-50 rounded-2xl shadow-xl p-6 md:p-8">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
            Create Forklift Booking
          </h2>
          {onClose && (
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition">
              <X size={28} />
            </button>
          )}
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">

          {/* ── STEP 1: Weight Category ── */}
          <div className="space-y-3">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white font-bold text-sm">1</div>
              <h3 className="text-lg font-semibold text-gray-800">Select Weight Category</h3>
            </div>

            {loadingWeights || loadingVehicles ? (
              <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl">
                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600" />
                <span className="text-gray-600 text-sm">Loading weight categories...</span>
              </div>
            ) : weightOptions.length === 0 ? (
              <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg text-yellow-700 text-sm">
                No weight categories available.
              </div>
            ) : (
              <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2">
                {weightOptions.map((opt) => {
                  const count = forkliftVehicles.filter(
                    (v) => v.weightCat === opt.value && v.oStatus === "Online"
                  ).length;
                  const active = selectedWeight === opt.value;
                  return (
                    <button
                      key={opt.value}
                      type="button"
                      disabled={count === 0}
                      onClick={() => {
                        setSelectedWeight(opt.value);
                        setFromLocation(null);
                        setToLocation(null);
                        setSuggestedVehicles([]);
                        setSelectedVehicle(null);
                        setAssignedResources([]);
                        setNeedsResources(false);
                      }}
                      className={`relative flex flex-col items-center justify-center p-3 rounded-xl border-2 font-semibold text-sm transition
                        ${count === 0
                          ? "opacity-40 cursor-not-allowed bg-gray-100 border-gray-200 text-gray-400"
                          : active
                          ? `${opt.color} ring-2 ring-offset-1 ring-blue-500 shadow-md scale-105`
                          : `${opt.color} hover:scale-105 hover:shadow cursor-pointer`
                        }`}
                    >
                      <Truck size={20} className="mb-1" />
                      {opt.label}
                      <span className={`text-xs mt-1 font-normal ${count === 0 ? "text-gray-400" : "opacity-70"}`}>
                        {count} available
                      </span>
                      {active && <CheckCircle size={14} className="absolute top-1 right-1 text-blue-600" />}
                    </button>
                  );
                })}
              </div>
            )}
          </div>

          {/* ── STEP 2: Locations ── */}
          {showStep2 && (
            <div className="space-y-4 pt-4 border-t border-gray-200">
              <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white font-bold text-sm">2</div>
                <h3 className="text-lg font-semibold text-gray-800">Select Locations</h3>
              </div>

              {loadingWorkAreas ? (
                <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600" />
                  <span className="text-gray-600 text-sm">Loading locations...</span>
                </div>
              ) : (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-gray-800 font-bold mb-2 flex items-center gap-2 text-sm">
                      <MapPin className="text-green-600" size={18} />
                      From Location <span className="text-red-500">*</span>
                    </label>
                    <Select
                      options={locationOptions}
                      value={fromLocation}
                      onChange={(opt) => {
                        setFromLocation(opt);
                        setSelectedVehicle(null);
                        if (toLocation && opt?.value === toLocation.value) setToLocation(null);
                      }}
                      placeholder="Select starting location..."
                      isClearable isSearchable
                      menuPortalTarget={document.body}
                      styles={selectPortalStyles}
                    />
                    {fromLocation && <p className="text-xs text-green-600 mt-1">✓ {fromLocation.label}</p>}
                  </div>
                  <div>
                    <label className="block text-gray-800 font-bold mb-2 flex items-center gap-2 text-sm">
                      <MapPin className="text-blue-600" size={18} />
                      To Location <span className="text-red-500">*</span>
                    </label>
                    <Select
                      options={locationOptions.filter((o) => o.value !== fromLocation?.value)}
                      value={toLocation}
                      onChange={(opt) => { setToLocation(opt); setSelectedVehicle(null); }}
                      placeholder="Select destination..."
                      isClearable isSearchable
                      menuPortalTarget={document.body}
                      styles={selectPortalStyles}
                    />
                    {toLocation && <p className="text-xs text-blue-600 mt-1">✓ {toLocation.label}</p>}
                  </div>
                </div>
              )}

              {fromLocation && toLocation && (
                <div className="flex items-center justify-center gap-3 p-3 bg-blue-50 rounded-lg text-sm font-semibold text-gray-700">
                  <span>{fromLocation.label}</span>
                  <ArrowRight className="text-blue-600" size={18} />
                  <span>{toLocation.label}</span>
                </div>
              )}
            </div>
          )}

          {/* ── STEP 3: Suggested Vehicle ── */}
          {showStep3 && (
            <div className="space-y-4 pt-4 border-t border-gray-200">
              <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white font-bold text-sm">3</div>
                <h3 className="text-lg font-semibold text-gray-800">Schedule Booking</h3>
                <span className="text-xs bg-yellow-100 text-yellow-700 px-2 py-0.5 rounded-full">Planned Booking</span>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                    <CalendarIcon className="text-blue-600" size={18} />
                    Booking Date <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    min={todayStr}
                    readOnly
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-600 focus:outline-none"
                  />
                </div>
                <div>
                  <CustomTimePicker
                    label="Start Time"
                    value={bsTime}
                    onChange={handleTimeChange}
                    required={true}
                    error={timeError}
                    placeholder="HH:MM"
                  />
                </div>
                <div>
                  <CustomTimePicker
                    label="Estimated End Time"
                    value={beTime}
                    onChange={handleEndTimeChange}
                    required={true}
                    error={endTimeError}
                    placeholder="HH:MM"
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    An estimate is fine - the actual end time is recorded when the driver completes the job.
                  </p>
                </div>
              </div>

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <p className="text-xs text-blue-700 flex items-center gap-2">
                  <CalendarIcon size={14} />
                  This is a <strong>scheduled/planned booking</strong>. The driver will receive an alert only at the selected start time.
                </p>
              </div>
            </div>            
          )}

          {/* ── STEP 4: Schedule Booking ── */}
          {showStep4 && (
            <div className="space-y-3 pt-4 border-t border-gray-200">
              <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white font-bold text-sm">4</div>
                <h3 className="text-lg font-semibold text-gray-800">Suggested Forklift</h3>
              </div>

              {suggestedVehicles.length === 0 ? (
                <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg text-yellow-700 text-sm">
                  No <strong>{selectedWeight}</strong> forklift available online.
                </div>
              ) : (
                <>
                  <p className="text-xs text-gray-500">
                    Showing the best available <strong>{selectedWeight}</strong> or higher forklift closest to <strong>{fromLocation?.label}</strong>
                  </p>
                  {(() => {
                    const v = suggestedVehicles[0];
                    const isSelected = selectedVehicle?.vehicleId === v.vehicleId;
                    const vLat = parseFloat(v.latitude || v.lat || v.currentLat || 0);
                    const vLng = parseFloat(v.longitude || v.lng || v.currentLng || 0);
                    const dist =
                      fromLocation?.lat && fromLocation?.lng && vLat && vLng
                        ? haversineKm(fromLocation.lat, fromLocation.lng, vLat, vLng).toFixed(1)
                        : null;
                    return (
                      <button
                        key={v.vehicleId}
                        type="button"
                        onClick={() => setSelectedVehicle(v)}
                        className={`w-full flex items-center justify-between p-4 rounded-xl border-2 text-left transition
                          ${isSelected
                            ? "border-green-500 bg-green-50 ring-2 ring-green-300"
                            : "border-gray-200 bg-white hover:border-blue-300 hover:bg-blue-50"
                          }`}
                      >
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm bg-amber-400 text-white">★</div>
                          <div>
                            <p className="font-semibold text-gray-800">{v.vehicleId}</p>
                            <p className="text-xs text-gray-500">
                              {v.weightCat} · Driver: {v.driverSno}
                              {dist ? ` · ~${dist} km away` : ""}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${v.oStatus === "Online" ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-500"}`}>
                            {v.oStatus || "Available"}
                          </span>
                          {isSelected && <CheckCircle size={18} className="text-green-600" />}
                        </div>
                      </button>
                    );
                  })()}
                </>
              )}
            </div>
          )}

          {/* ── STEP 5: Additional Resources (NEW) ── */}
          {showStep5 && (
            <div className="space-y-4 pt-4 border-t border-gray-200">
              <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-indigo-600 text-white font-bold text-sm">5</div>
                <h3 className="text-lg font-semibold text-gray-800">Additional Resources</h3>
                <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full">Optional</span>
              </div>

              {/* Checkbox to toggle resources */}
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
                <label className="flex items-start gap-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={needsResources}
                    onChange={(e) => {
                      setNeedsResources(e.target.checked);
                      if (!e.target.checked) setAssignedResources([]);
                    }}
                    className="w-4 h-4 mt-0.5 rounded border-gray-300 accent-indigo-600"
                  />
                  <div>
                    <span className="text-sm font-semibold text-gray-800">
                      Need additional resources?
                    </span>
                    <p className="text-xs text-gray-500 mt-0.5">
                      Trailer, Crane — Only ONE resource type can be selected per booking
                    </p>
                  </div>
                </label>
              </div>

              {/* Resource picker - All 3 types */}
              {needsResources && (
                <div className="border-2 border-dashed border-indigo-200 rounded-xl p-4 bg-gradient-to-br from-indigo-50/40 to-purple-50/30 space-y-4">
                  <h4 className="text-sm font-semibold text-gray-800 flex items-center gap-2">
                    <Layers size={16} className="text-indigo-600" />
                    Select Resource Type
                    <span className="text-xs font-normal text-gray-500">(tap to select · tap again to deselect)</span>
                  </h4>

                  {/* 3 resource buttons in a grid */}
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    {RESOURCE_TYPES.map((type) => {
                      const meta = RESOURCE_META[type];
                      const isSelected = assignedResources.some((r) => r.type === type);
                      const isDisabled = assignedResources.length > 0 && !isSelected;

                      return (
                        <button
                          key={type}
                          type="button"
                          onClick={() => handleAddResource(type)}
                          className={`relative flex flex-col items-center justify-center py-4 px-3 rounded-xl border-2 font-medium text-sm transition-all duration-200
                            ${isSelected
                              ? meta.activeColor + " shadow-lg scale-[1.03] ring-2 ring-offset-2 ring-indigo-400"
                              : isDisabled
                              ? "border-gray-200 bg-gray-50 text-gray-400 cursor-pointer hover:opacity-80"
                              : meta.color + " hover:scale-[1.03] hover:shadow-md cursor-pointer"
                            }`}
                          title={isDisabled ? `Click to switch to ${type}` : isSelected ? `Click to remove ${type}` : `Click to select ${type}`}
                        >
                          <span className="text-2xl mb-2">{meta.icon}</span>
                          <span className="text-center font-semibold leading-tight">
                            {type}
                          </span>
                          <span className={`text-xs mt-1 font-mono px-1.5 py-0.5 rounded ${isSelected ? "bg-white/30" : meta.badge}`}>
                            Code: {getResourceTypeCode(type)}
                          </span>
                          {isSelected && (
                            <div className="absolute top-2 right-2">
                              <CheckCircle size={16} className="text-white drop-shadow" />
                            </div>
                          )}
                          {isDisabled && (
                            <span className="text-[10px] mt-1 opacity-60">tap to switch</span>
                          )}
                        </button>
                      );
                    })}
                  </div>

                  {/* Status */}
                  {assignedResources.length === 0 && (
                    <div className="flex items-center gap-2 text-xs text-amber-600 bg-amber-50 border border-amber-200 rounded-lg p-2">
                      <AlertCircle size={14} />
                      Please select one resource type above
                    </div>
                  )}
                  {assignedResources.length > 0 && (
                    <div className="flex items-center justify-between bg-white rounded-lg p-3 border border-indigo-100">
                      <div className="flex items-center gap-2">
                        <span className="text-lg">{RESOURCE_META[assignedResources[0].type]?.icon}</span>
                        <div>
                          <p className="text-sm font-semibold text-gray-800">{assignedResources[0].type}</p>
                          <p className="text-xs text-gray-500">
                            Code:{" "}
                            <span className="font-mono bg-gray-100 px-1 rounded">
                              {assignedResources[0].vehicleCode}
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="text-xs text-emerald-600 font-medium flex items-center gap-1">
                          <CheckCircle size={12} /> Selected
                        </span>
                        <button
                          type="button"
                          onClick={() => handleRemoveResource(assignedResources[0].id)}
                          className="text-red-400 hover:text-red-600 p-1 hover:bg-red-50 rounded transition"
                        >
                          <Trash2 size={14} />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* ── Summary ── */}
          {showStep4 && bsTime && (
            <div className="bg-gradient-to-br from-blue-100 to-indigo-100 p-5 rounded-xl border-2 border-blue-300">
              <h4 className="font-semibold text-blue-900 mb-3">📋 Booking Summary</h4>
              <div className="grid grid-cols-2 gap-3 text-sm">
                <div>
                  <span className="text-blue-700 font-medium">Vehicle:</span>
                  <p className="text-gray-800 font-semibold">{selectedVehicle.vehicleId}</p>
                </div>
                <div>
                  <span className="text-blue-700 font-medium">Capacity:</span>
                  <p className="text-gray-800">{selectedVehicle.weightCat}</p>
                </div>
                <div>
                  <span className="text-blue-700 font-medium">Driver:</span>
                  <p className="text-gray-800">{selectedVehicle.driverSno}</p>
                </div>
                <div>
                  <span className="text-blue-700 font-medium">Date & Time:</span>
                  <p className="text-gray-800 font-semibold">{selectedDate} {bsTime}</p>
                </div>
                <div className="col-span-2">
                  <span className="text-blue-700 font-medium">Route:</span>
                  <p className="text-gray-800 flex items-center gap-2 flex-wrap">
                    <span>{fromLocation.label}</span>
                    <ArrowRight size={14} />
                    <span>{toLocation.label}</span>
                  </p>
                </div>
                {/* Resource in summary */}
                {needsResources && assignedResources.length > 0 && (
                  <div className="col-span-2 pt-2 border-t border-blue-200">
                    <span className="text-blue-700 font-medium flex items-center gap-1">
                      <Layers size={12} /> Resource:
                    </span>
                    <p className="text-gray-800 flex items-center gap-2 mt-0.5">
                      <span>{RESOURCE_META[assignedResources[0].type]?.icon}</span>
                      <span className="font-semibold">{assignedResources[0].type}</span>
                      <span className="font-mono text-xs bg-blue-200 px-1.5 rounded">
                        {assignedResources[0].vehicleCode}
                      </span>
                    </p>
                  </div>
                )}
                <div className="col-span-2 mt-2 pt-2 border-t border-blue-200">
                  <p className="text-xs text-blue-700 flex items-center gap-1">
                    <CalendarIcon size={12} />
                    <strong>Planned:</strong> Driver notified on {selectedDate} at {bsTime}
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* TC-02 - the suggested forklift was taken between suggestion and confirm */}
          {conflictNotice && (
            <div className="p-3 bg-amber-50 border border-amber-300 rounded-lg text-amber-800 text-sm font-medium">
              {conflictNotice}
            </div>
          )}

          {/* ── Buttons ── */}
          <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
            {onClose && (
              <button
                type="button"
                onClick={onClose}
                className="px-6 py-3 rounded-lg font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 transition"
              >
                Cancel
              </button>
            )}
            <button
              type="submit"
              disabled={
                !showStep4 ||
                !bsTime ||
                !beTime ||
                isSubmitting ||
                !!timeError ||
                !!endTimeError ||
                (needsResources && assignedResources.length === 0)
              }
              className={`px-8 py-3 rounded-lg font-bold text-white transition
                ${showStep4 && bsTime && beTime && !isSubmitting && !timeError && !endTimeError && !(needsResources && assignedResources.length === 0)
                  ? "bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 shadow-lg"
                  : "bg-gray-400 cursor-not-allowed"
                }`}
            >
              {isSubmitting ? "Creating Booking..." : "Schedule Forklift Booking"}
            </button>
          </div>
        </form>
      </div>

      {/* ── Success Overlay ── */}
      {showBookingOverlay && submittedBooking && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center px-4 z-50 animate-fadeIn">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 sm:p-8 relative animate-slideUp">
            <button
              onClick={() => { setShowBookingOverlay(false); if (onClose) onClose(); }}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition"
            >
              <X size={24} />
            </button>

            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                <CheckCircle size={40} className="text-green-600" />
              </div>
            </div>

            <h2 className="text-2xl font-bold text-center text-gray-800 mb-2">
              Forklift Booking Scheduled!
            </h2>
            <p className="text-center text-gray-600 mb-6">
              Driver will be notified at the scheduled time
            </p>

            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-4 space-y-3 mb-6">
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Booking ID:</span>
                <span className="font-bold text-blue-700">#{submittedBooking.bId || "Pending"}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Scheduled For:</span>
                <span className="font-semibold text-blue-700">{submittedBooking.scheduledFor}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Vehicle:</span>
                <span className="font-semibold text-gray-800">
                  {submittedBooking.vehicleType} ({submittedBooking.weightCat})
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Driver:</span>
                <span className="font-semibold text-gray-800">{submittedBooking.driverName}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Route:</span>
                <span className="font-semibold text-gray-800 text-sm truncate max-w-[200px]">
                  {submittedBooking.From} → {submittedBooking.TO}
                </span>
              </div>
              {/* Resource in overlay */}
              {submittedBooking.resourceType && (
                <div className="flex justify-between items-center pt-2 border-t border-blue-200">
                  <span className="text-sm text-gray-600 flex items-center gap-1">
                    <Layers size={12} /> Resource:
                  </span>
                  <span className="font-semibold text-indigo-700 flex items-center gap-1">
                    {RESOURCE_META[submittedBooking.resourceType]?.icon}{" "}
                    {submittedBooking.resourceType}
                    <span className="font-mono text-xs bg-indigo-100 px-1 rounded ml-1">
                      {submittedBooking.resourceCode}
                    </span>
                  </span>
                </div>
              )}
            </div>

            <p className="text-center text-sm text-gray-500">Closing in a moment...</p>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
        .animate-fadeIn { animation: fadeIn 0.3s ease-out; }
        .animate-slideUp { animation: slideUp 0.4s ease-out; }
      `}</style>
    </>
  );
}